export interface paths {
  '/admin/analytics/overview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminAnalyticsControllerGetPlatformAnalytics'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/app-versions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminAppVersionControllerFindAll'];
    put?: never;
    post: operations['adminAppVersionControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/app-versions/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminAppVersionControllerFindById'];
    put: operations['adminAppVersionControllerUpdate'];
    post?: never;
    delete: operations['adminAppVersionControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/jobs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBackgroundJobControllerListJobs'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/jobs/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBackgroundJobControllerGetJobProgress'];
    put?: never;
    post?: never;
    delete: operations['adminBackgroundJobControllerDeleteJob'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/jobs/{id}/pause': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminBackgroundJobControllerPauseJob'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/jobs/{id}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminBackgroundJobControllerCancelJob'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessControllerFindAll'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessControllerFindById'];
    put: operations['adminBusinessControllerUpdate'];
    post?: never;
    delete: operations['adminBusinessControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['adminBusinessControllerUpdateStatus'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}/reviews': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessControllerGetReviews'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}/reviews/{reviewId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['adminBusinessControllerToggleReview'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}/images/{imageId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: operations['adminBusinessImageControllerDeleteImage'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}/images/{imageId}/primary': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['adminBusinessImageControllerSetPrimaryImage'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessImportControllerGetStatus'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/fetch-details': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminBusinessImportControllerFetchPlaceDetails'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/businesses': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminBusinessImportControllerImportBusinesses'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/businesses/{id}/refresh-preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessImportControllerGetRefreshPreview'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/businesses/{id}/refresh': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminBusinessImportControllerApplyRefreshChanges'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/businesses/{id}/map-reference': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessImportControllerGetMapReference'];
    put: operations['adminBusinessImportControllerUpdateMapReference'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/businesses/{id}/map-reference/preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessImportControllerPreviewMapReferenceUpdate'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/categories': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminCategoryControllerFindAll'];
    put?: never;
    post: operations['adminCategoryControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/categories/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminCategoryControllerFindById'];
    put: operations['adminCategoryControllerUpdate'];
    post?: never;
    delete: operations['adminCategoryControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/entity-logs/{entityType}/{entityId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminEntityLogsControllerGetEntityLogs'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/event-report/options': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** @description Get available event types, groupBy options, and entity types */
    get: operations['adminEventReportControllerGetOptions'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/event-report/generate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** @description Generate an event report based on filters */
    get: operations['adminEventReportControllerGenerateReport'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/event-report/export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** @description Export event report as CSV */
    get: operations['adminEventReportControllerExportCsv'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/filters': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminFilterControllerFindAll'];
    put?: never;
    post: operations['adminFilterControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/filters/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminFilterControllerFindById'];
    put: operations['adminFilterControllerUpdate'];
    post?: never;
    delete: operations['adminFilterControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/providers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminImportJobControllerGetProviders'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminImportJobControllerListJobs'];
    put?: never;
    post: operations['adminImportJobControllerCreateJob'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminImportJobControllerGetJobProgress'];
    put?: never;
    post?: never;
    delete: operations['adminImportJobControllerDeleteJob'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}/items': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminImportJobControllerGetJobItems'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}/pause': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminImportJobControllerPauseJob'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}/resume': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminImportJobControllerResumeJob'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}/retry': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminImportJobControllerRetryFailedItems'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminImportJobControllerCancelJob'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/notifications': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminNotificationControllerFindAll'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/notifications/send': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminNotificationControllerSend'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/notifications/send-bulk': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminNotificationControllerSendBulk'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/notifications/broadcast': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminNotificationControllerBroadcast'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/notifications/user/{userId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminNotificationControllerFindByUser'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{userId}/plans': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminPlanControllerFindAllByUser'];
    put?: never;
    post: operations['adminPlanControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{userId}/plans/{planId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: operations['adminPlanControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/scores/recalculate-all': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Queue score recalculation for all active businesses
     * @description Queues a background job to recalculate work-friendly scores for all active businesses. Returns the background job ID for tracking progress.
     */
    post: operations['adminScoresControllerRecalculateAllScores'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/scores/recalculate/{businessId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Immediately recalculate score for a single business
     * @description Synchronously recalculates the work-friendly score for a specific business. Use this for testing or when you need immediate results.
     */
    post: operations['adminScoresControllerRecalculateSingleScore'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminUsersControllerFindAll'];
    put?: never;
    post: operations['adminUsersControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/me': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminUsersControllerGetMe'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{id}/auth-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminUsersControllerGetAuthProfile'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminUsersControllerFindById'];
    put: operations['adminUsersControllerUpdate'];
    post?: never;
    delete: operations['adminUsersControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{id}/role': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['adminUsersControllerUpdateRole'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{id}/abilities': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminUsersControllerGetUserAbilities'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['businessControllerCreateBusiness'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/cities': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessControllerGetCities'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/findNearby': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessControllerFindNearby'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/findWithinArea': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessControllerFindWithinArea'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/findByName': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessControllerFindByName'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/checkByProvider': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessControllerCheckBusinessByProvider'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/{businessId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessIdControllerFindById'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/{businessId}/reviews': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessReviewsControllerFindReviews'];
    put?: never;
    post: operations['businessReviewsControllerCreateReview'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/{businessId}/reviews/{reviewId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['businessReviewsControllerUpdateReview'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/category': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['categoryControllerGetAll'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/config/ping': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['configControllerHealthCheck'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/config/version': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['configControllerGetAppVersion'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/favorite': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['favoriteControllerGetFavorites'];
    put?: never;
    post: operations['favoriteControllerSetFavoriteStatus'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/filter': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['filterControllerGetAll'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/img/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get display image (most common use)
     * @description Returns the display-sized image URL (800px, WebP)
     */
    get: operations['imageControllerGetDisplayImage'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/img/{id}/thumb': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get thumbnail image
     * @description Returns the thumbnail-sized image URL (200px, WebP)
     */
    get: operations['imageControllerGetThumbnail'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/img/{id}/original': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get original image
     * @description Returns the original-sized image URL (1600px, WebP)
     */
    get: operations['imageControllerGetOriginal'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/img/{id}/size': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get image by size preference
     * @description Returns image based on width requirement
     */
    get: operations['imageControllerGetBySize'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/notification': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['notificationControllerFindAll'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/notification/unread-count': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['notificationControllerGetUnreadCount'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/notification/{notificationId}/read': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['notificationControllerMarkAsRead'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/notification/read-all': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['notificationControllerMarkAllAsRead'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/notification/settings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['notificationControllerGetSettings'];
    put: operations['notificationControllerUpdateSettings'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/plan': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['planControllerGetByUser'];
    put?: never;
    post: operations['planControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/plan/{planId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: operations['planControllerDeletePlan'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['userControllerFindById'];
    put: operations['userControllerUpdateUser'];
    post: operations['userControllerCreate'];
    delete: operations['userControllerDeleteAccount'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/social': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['userControllerCreateSocialUser'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/auth-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['userControllerGetAuthProfile'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/push-token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['userControllerSavePushToken'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/onboarding': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch: operations['userControllerCompleteOnboarding'];
    trace?: never;
  };
  '/user-events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['userEventControllerTrackEvent'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/.well-known/apple-app-site-association': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['webControllerAppleAppSiteAssociation'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/.well-known/assetlinks.json': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['webControllerDigitalAssetLinks'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/b/{businessId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['webControllerBusinessWebFallback'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/b/{businessId}/{slug}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['webControllerBusinessWebFallbackWithSlug'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    AppVersion: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      platform: string;
      minimumVersion: string;
      latestVersion: string;
      forceUpdate?: boolean;
      updateMessage?: string;
      appStoreUrl?: string;
      enabled?: boolean;
    };
    NotFound: {
      /**
       * @description The error name
       * @default NOT_FOUND
       * @example NOT_FOUND
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 404
       * @example 404
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    GenericError: {
      /** @description The error name */
      name: string;
      /** @description An error message */
      message: string;
    } & {
      [key: string]: unknown;
    };
    AdminAppVersionCreateDTO: {
      platform: string;
      minimumVersion: string;
      latestVersion: string;
      /** @default false */
      forceUpdate: boolean;
      updateMessage?: string;
      appStoreUrl?: string;
      /** @default true */
      enabled: boolean;
    };
    AdminAppVersionUpdateDTO: {
      minimumVersion?: string;
      latestVersion?: string;
      forceUpdate?: boolean;
      updateMessage?: string;
      appStoreUrl?: string;
      enabled?: boolean;
    };
    BackgroundJobListDTO: {
      id: number;
      /** @enum {string} */
      type: BackgroundJobListDTOType;
      /** @enum {string} */
      status: BackgroundJobListDTOStatus;
      totalItems: number;
      processedItems: number;
      successfulItems: number;
      failedItems: number;
      skippedItems: number;
      percentComplete: number;
      createdAt: string;
    };
    BackgroundJobProgressDTO: {
      id: number;
      /** @enum {string} */
      type: BackgroundJobProgressDTOType;
      /** @enum {string} */
      status: BackgroundJobProgressDTOStatus;
      totalItems: number;
      processedItems: number;
      successfulItems: number;
      failedItems: number;
      skippedItems: number;
      percentComplete: number;
      metadata?: Record<string, never>;
      createdAt: string;
      updatedAt: string;
    };
    Business: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      name: string;
      address: string;
      postalCode: string;
      city: string;
      province?: string;
      country: string;
      /** Format: url */
      website?: string;
      phone?: string;
      location?: components['schemas']['GeographyPoint'];
      /** @enum {string} */
      status?: BusinessStatus;
      workFriendlyScore?: number;
      approvedReviewCount?: number;
      scoreConfidence?: number;
      timezone?: string;
      scoreCalculatedAt?: string;
      distance?: number;
      images?: components['schemas']['BusinessImage'][];
      openingHours?: components['schemas']['BusinessOpeningHour'][];
      filters?: components['schemas']['BusinessFilter'][];
      businessCategories?: components['schemas']['BusinessCategory'][];
      reviews?: components['schemas']['BusinessReview'][];
      isFavorite?: boolean;
      hasVisited?: boolean;
    };
    GeographyPoint: {
      type: string;
      coordinates: number[];
    };
    BusinessImage: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      image?: components['schemas']['Image'];
      primary: boolean;
    };
    Image: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      /** Format: url */
      primaryUrl: string;
      variants?: unknown[];
    };
    BusinessOpeningHour: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      /** @enum {number} */
      dayOfWeek: BusinessOpeningHourDayOfWeek;
      openTime: string;
      closeTime: string;
    };
    BusinessFilter: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      filter: components['schemas']['Filter'];
      /** @enum {string} */
      level: BusinessFilterLevel;
    };
    Filter: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      name: string;
      enabled?: boolean;
      isMandatory?: boolean;
      /** @enum {string} */
      importance?: FilterImportance;
      /** @enum {string} */
      notAvailableImpact?: FilterNotAvailableImpact;
      businessCount?: number;
    };
    BusinessCategory: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      category: Record<string, never>;
      isPrimary?: boolean;
    };
    BusinessReview: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      user?: Record<string, never>;
      review?: string;
      filters?: components['schemas']['BusinessReviewFilter'][];
      isEvaluated?: boolean;
      editedAt?: string;
    };
    BusinessReviewFilter: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      filter: components['schemas']['Filter'];
      /** @enum {string} */
      level?: BusinessReviewFilterLevel;
    };
    AdminBusinessUpdateDTO: {
      name?: string;
      address?: string;
      postalCode?: string;
      city?: string;
      province?: string;
      country?: string;
      /** Format: url */
      website?: string;
      phone?: string;
      /** @enum {string} */
      status?: AdminBusinessUpdateDTOStatus;
      categoryIds?: number[];
      filterIds?: number[];
      openingHours?: components['schemas']['AdminOpeningHourDTO'][];
    };
    AdminOpeningHourDTO: {
      id?: number;
      /** @enum {number} */
      dayOfWeek?: AdminOpeningHourDTODayOfWeek;
      openTime?: string;
      closeTime?: string;
    };
    AdminBusinessStatusUpdateDTO: {
      /** @enum {string} */
      status?: AdminBusinessStatusUpdateDTOStatus;
    };
    AdminReviewToggleDTO: {
      isEvaluated?: boolean;
    };
    BadRequest: {
      /**
       * @description The error name
       * @default BAD_REQUEST
       * @example BAD_REQUEST
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 400
       * @example 400
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    MapProviderStatusDTO: {
      configured: boolean;
      message?: string;
      provider: components['schemas']['MapProviderInfoDTO'];
    };
    MapProviderInfoDTO: {
      /** @enum {string} */
      identifier: MapProviderInfoDTOIdentifier;
      name: string;
    };
    FetchPlaceDetailsDTO: {
      placeIds: string[];
    };
    BulkImportProgressDTO: {
      total: number;
      processed: number;
      successful: number;
      failed: number;
      skipped: number;
      results?: components['schemas']['ImportResultDTO'][];
    };
    ImportResultDTO: {
      success: boolean;
      businessId?: number;
      businessName?: string;
      placeId: string;
      error?: string;
    };
    ImportBusinessesDTO: {
      placeIds: string[];
      categoryIds?: number[];
      filterIds?: number[];
      /**
       * @default Pending
       * @enum {string}
       */
      status: ImportBusinessesDTOStatus;
      /** @default true */
      skipExisting: boolean;
    };
    RefreshComparisonDTO: {
      hasChanges: boolean;
      nameChange?: components['schemas']['RefreshChangeDTO'];
      addressChange?: components['schemas']['RefreshChangeDTO'];
      phoneChange?: components['schemas']['RefreshChangeDTO'];
      websiteChange?: components['schemas']['RefreshChangeDTO'];
      openingHoursChange?: components['schemas']['OpeningHoursChangeDTO'];
      newPhotosCount: number;
      newPhotos?: components['schemas']['SyncDataPhotoDTO'][];
      lastSyncedAt?: string;
      cachedResponse?: components['schemas']['CachedMapResponseDTO'];
      provider: components['schemas']['MapProviderInfoDTO'];
    };
    RefreshChangeDTO: {
      old?: Record<string, never>;
      new?: Record<string, never>;
    };
    OpeningHoursChangeDTO: {
      old?: unknown[];
      new?: unknown[];
    };
    SyncDataPhotoDTO: {
      widthPx: number;
      heightPx: number;
      authorName?: string;
      authorUri?: string;
    };
    CachedMapResponseDTO: {
      fetchedAt: string;
      /** @enum {string} */
      provider: CachedMapResponseDTOProvider;
      data: components['schemas']['MapProviderRawDataDTO'];
    };
    MapProviderRawDataDTO: {
      [key: string]: unknown;
    };
    ApplyRefreshChangesDTO: {
      /** @default false */
      applyName: boolean;
      /** @default false */
      applyAddress: boolean;
      /** @default false */
      applyPhone: boolean;
      /** @default false */
      applyWebsite: boolean;
      /** @default false */
      applyOpeningHours: boolean;
      /** @default false */
      addNewPhotos: boolean;
      cachedResponse?: components['schemas']['CachedMapResponseDTO'];
    };
    BusinessMapReferenceInfoDTO: {
      provider: components['schemas']['MapProviderInfoDTO'];
      externalId: string;
      lastSyncedAt?: string;
    };
    UpdateMapReferencePreviewDTO: {
      currentPlaceId: string;
      newPlaceId: string;
      provider: components['schemas']['MapProviderInfoDTO'];
      newPlaceData: components['schemas']['ParsedPlaceDataDTO'];
    };
    ParsedPlaceDataDTO: {
      name?: string;
      address?: string;
      city?: string;
      province?: string;
      postalCode?: string;
      country?: string;
      phone?: string;
      website?: string;
      rating?: number;
      userRatingsTotal?: number;
      photoCount?: number;
      externalUri?: string;
    };
    UpdateMapReferenceDTO: {
      newPlaceId: string;
    };
    Category: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      name: string;
      enabled?: boolean;
      businessCount?: number;
    };
    AdminCategoryCreateDTO: {
      name: string;
    };
    AdminCategoryUpdateDTO: {
      name?: string;
      enabled?: boolean;
    };
    EntityLogDTO: {
      id?: number;
      eventType?: string;
      properties?: {
        [key: string]: unknown;
      };
      createdAt?: string;
      user?: components['schemas']['EntityLogUserDTO'];
    };
    EntityLogUserDTO: {
      id?: number;
      firstName?: string;
      lastName?: string;
    };
    ReportOptionsResponse: {
      eventTypes?: string[];
      groupByOptions?: string[];
      entityTypes?: string[];
    };
    AdminFilterCreateDTO: {
      name: string;
      /** @default false */
      isMandatory: boolean;
    };
    AdminFilterUpdateDTO: {
      name?: string;
      enabled?: boolean;
      isMandatory?: boolean;
    };
    ImportJobProgressDTO: {
      id: number;
      /** @enum {string} */
      status: ImportJobProgressDTOStatus;
      provider: string;
      totalItems: number;
      processedItems: number;
      successfulItems: number;
      failedItems: number;
      skippedItems: number;
      percentComplete: number;
      createdAt: string;
      updatedAt: string;
    };
    CreateImportJobDTO: {
      provider: string;
      externalIds?: string[];
      urls?: string[];
      /** @default Pending */
      businessStatus: string;
    };
    ImportJobListDTO: {
      id: number;
      /** @enum {string} */
      status: ImportJobListDTOStatus;
      provider: string;
      totalItems: number;
      processedItems: number;
      successfulItems: number;
      failedItems: number;
      createdAt: string;
    };
    ImportJobItemDTO: {
      id: number;
      externalId: string;
      /** @enum {string} */
      status: ImportJobItemDTOStatus;
      businessId?: number;
      businessName?: string;
      error?: string;
      processedAt?: string;
    };
    Notification: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      userId: number;
      title: string;
      body: string;
      /** @enum {string} */
      type: NotificationType;
      /** @enum {string} */
      source: NotificationSource;
      /** @default false */
      isRead: boolean;
      readAt?: string;
      /** @default false */
      isPushSent: boolean;
      pushSentAt?: string;
      data?: Record<string, never>;
      sentByAdminId?: number;
    };
    AdminSendNotificationDTO: {
      userId: number;
      title: string;
      body: string;
      /** @enum {string} */
      type: AdminSendNotificationDTOType;
    };
    AdminSendBulkNotificationDTO: {
      userIds: unknown[];
      title: string;
      body: string;
      /** @enum {string} */
      type: AdminSendBulkNotificationDTOType;
    };
    AdminSendBroadcastDTO: {
      title: string;
      body: string;
      /** @enum {string} */
      type: AdminSendBroadcastDTOType;
    };
    Plan: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      user: components['schemas']['User'];
      business: components['schemas']['Business'];
      startAt: string;
      endAt: string;
      createdByAdmin?: boolean;
      /** Format: date-time */
      reminderSentAt?: string;
      /** Format: date-time */
      reviewReminderSentAt?: string;
      canReviewBusiness?: boolean;
    };
    User: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      firstName: string;
      lastName: string;
      enabled?: boolean;
      disabledAt?: string;
      pushEnabled?: boolean;
      planRemindersEnabled?: boolean;
      marketingEnabled?: boolean;
      announcementsEnabled?: boolean;
      devicePushGranted?: boolean;
      lastPermissionCheckAt?: string;
      onboardingCompletedAt?: string;
      roles?: string[];
      customPermissions?: string[];
    };
    AdminPlanCreateDTO: {
      businessId: number;
      /** Format: date-time */
      startAt: string;
      /** Format: date-time */
      endAt: string;
    };
    BatchRecalculationResponse: {
      jobId?: number;
      queued?: number;
    };
    SingleRecalculationResponse: {
      businessId?: number;
      score?: number;
      reviewCount?: number;
      confidence?: number;
    };
    UserRoleUpdateDTO: {
      /** @enum {string} */
      role: UserRoleUpdateDTORole;
      subject?: string;
    };
    AdminUserCreateDTO: {
      /** Format: email */
      email: string;
      phone?: string;
      password: string;
      firstName: string;
      lastName: string;
      /** @enum {string} */
      role: AdminUserCreateDTORole;
      subject?: string;
    };
    AdminUserUpdateDTO: {
      /** Format: email */
      email?: string;
      phone?: string;
      firstName: string;
      lastName: string;
      /** @enum {string} */
      role?: AdminUserUpdateDTORole;
      subject?: string;
      enabled?: boolean;
    };
    BusinessCreateDTO: {
      name: string;
      address: string;
      postalCode: string;
      city: string;
      province?: string;
      country: string;
      /** Format: url */
      website?: string;
      phone?: string;
      location: components['schemas']['GeographyPoint'];
      images: string[];
      primaryImageIndex: number;
      categoriesIds: number[];
      filterIds?: number[];
      openingHours: components['schemas']['BusinessCreateOpeningHourDTO'][];
      review?: components['schemas']['BusinessCreateReviewDTO'];
      mapProvider: components['schemas']['BusinessCreateMapProviderDTO'];
    };
    BusinessCreateOpeningHourDTO: {
      /** @enum {number} */
      dayOfWeek: BusinessCreateOpeningHourDTODayOfWeek;
      openTime: string;
      closeTime: string;
    };
    BusinessCreateReviewDTO: {
      text?: string;
      ratings: components['schemas']['BusinessCreateRatingDTO'][];
    };
    BusinessCreateRatingDTO: {
      filterId: number;
      /** @enum {string} */
      level: BusinessCreateRatingDTOLevel;
    };
    BusinessCreateMapProviderDTO: {
      providerId: string;
      externalId: string;
    };
    CityWithBusinessCount: {
      city: string;
      country: string;
      businessCount: number;
      latitude: number;
      longitude: number;
    };
    BusinessReviewCreateDTO: {
      review?: string;
      filters?: components['schemas']['BusinessReviewFilterCreateDTO'][];
    };
    BusinessReviewFilterCreateDTO: {
      filterId: number;
      /** @enum {string} */
      level: BusinessReviewFilterCreateDTOLevel;
    };
    Conflict: {
      /**
       * @description The error name
       * @default CONFLICT
       * @example CONFLICT
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 409
       * @example 409
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    Forbidden: {
      /**
       * @description The error name
       * @default FORBIDDEN
       * @example FORBIDDEN
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 403
       * @example 403
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    InternalServerError: {
      /**
       * @description The error name
       * @default INTERNAL_SERVER_ERROR
       * @example INTERNAL_SERVER_ERROR
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 500
       * @example 500
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    VersionResponse: {
      needsUpdate: boolean;
      forceUpdate: boolean;
      updateMessage?: string;
      appStoreUrl?: string;
      latestVersion?: string;
      minimumVersion?: string;
    };
    Favorite: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      business: Record<string, never>;
    };
    FavoriteUpdateDTO: {
      businessId: number;
      isFavorite: boolean;
    };
    ImageResponse: {
      url: string;
      format: string;
      size: string;
      width: number;
      height: number;
    };
    UnreadCountResponse: Record<string, never>;
    NotificationSettingsResponseDTO: {
      pushEnabled?: boolean;
      planRemindersEnabled?: boolean;
      marketingEnabled?: boolean;
      announcementsEnabled?: boolean;
    };
    NotificationSettingsUpdateRequestDTO: {
      pushEnabled?: boolean;
      planRemindersEnabled?: boolean;
      marketingEnabled?: boolean;
      announcementsEnabled?: boolean;
    };
    Unauthorized: {
      /**
       * @description The error name
       * @default UNAUTHORIZED
       * @example UNAUTHORIZED
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 401
       * @example 401
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    PlanCreateDTO: {
      businessId: number;
      /** Format: date-time */
      startAt: string;
      /** Format: date-time */
      endAt: string;
    };
    UserCreateDTO: {
      /** Format: email */
      email: string;
      phone?: string;
      password: string;
      firstName: string;
      lastName: string;
    };
    SocialUserCreateDTO: {
      firstName: string;
      lastName: string;
    };
    UserUpdateDTO: {
      /** Format: email */
      email?: string;
      phone?: string;
      firstName: string;
      lastName: string;
    };
    PushToken: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      userId: number;
      expoPushToken: string;
      deviceType?: string;
      isActive?: boolean;
    };
    PushTokenCreateDTO: {
      expoPushToken: string;
      deviceType?: string;
      devicePermissionGranted?: boolean;
    };
    UserEvent: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      eventType?: string;
      /** @enum {string} */
      entityType?: UserEventEntityType;
      entityId?: number;
      properties?: Record<string, never>;
      /** @enum {string} */
      source?: UserEventSource;
    };
    UserEventCreateDTO: {
      /** @enum {string} */
      eventType: UserEventCreateDTOEventType;
      /** @enum {string} */
      entityType?: UserEventCreateDTOEntityType;
      entityId?: number;
      properties?: {
        [key: string]: unknown;
      };
      /** @enum {string} */
      source?: UserEventCreateDTOSource;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
  adminAnalyticsControllerGetPlatformAnalytics: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': unknown;
        };
      };
    };
  };
  adminAppVersionControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        platform?: string;
        enabled?: boolean;
        sortBy?: string;
        sortOrder?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AppVersion'][];
        };
      };
    };
  };
  adminAppVersionControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminAppVersionCreateDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AppVersion'];
        };
      };
    };
  };
  adminAppVersionControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AppVersion'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminAppVersionControllerUpdate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminAppVersionUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AppVersion'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminAppVersionControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBackgroundJobControllerListJobs: {
    parameters: {
      query?: {
        type?: string;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BackgroundJobListDTO'][];
        };
      };
    };
  };
  adminBackgroundJobControllerGetJobProgress: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BackgroundJobProgressDTO'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBackgroundJobControllerDeleteJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  adminBackgroundJobControllerPauseJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BackgroundJobProgressDTO'];
        };
      };
    };
  };
  adminBackgroundJobControllerCancelJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BackgroundJobProgressDTO'];
        };
      };
    };
  };
  adminBusinessControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        search?: string;
        status?: PathsAdminBusinessesGetParametersQueryStatus;
        categoryId?: number;
        country?: string;
        city?: string;
        sortBy?: string;
        sortOrder?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'][];
        };
      };
    };
  };
  adminBusinessControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessControllerUpdate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminBusinessUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessControllerUpdateStatus: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminBusinessStatusUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessControllerGetReviews: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
      };
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessReview'][];
        };
      };
    };
  };
  adminBusinessControllerToggleReview: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
        reviewId: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminReviewToggleDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessReview'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessImageControllerDeleteImage: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
        imageId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessImageControllerSetPrimaryImage: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
        imageId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessImportControllerGetStatus: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MapProviderStatusDTO'];
        };
      };
    };
  };
  adminBusinessImportControllerFetchPlaceDetails: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['FetchPlaceDetailsDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': Record<string, never>;
        };
      };
    };
  };
  adminBusinessImportControllerImportBusinesses: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['ImportBusinessesDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkImportProgressDTO'];
        };
      };
    };
  };
  adminBusinessImportControllerGetRefreshPreview: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RefreshComparisonDTO'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessImportControllerApplyRefreshChanges: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['ApplyRefreshChangesDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessImportControllerGetMapReference: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessMapReferenceInfoDTO'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessImportControllerUpdateMapReference: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UpdateMapReferenceDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessImportControllerPreviewMapReferenceUpdate: {
    parameters: {
      query?: {
        newPlaceId?: string;
      };
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateMapReferencePreviewDTO'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminCategoryControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        search?: string;
        enabled?: boolean;
        sortBy?: string;
        sortOrder?: string;
        noPagination?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Category'][];
        };
      };
    };
  };
  adminCategoryControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminCategoryCreateDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Category'];
        };
      };
    };
  };
  adminCategoryControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Category'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminCategoryControllerUpdate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminCategoryUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Category'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminCategoryControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminEntityLogsControllerGetEntityLogs: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        excludeViews?: string;
      };
      header?: never;
      path: {
        entityType: string;
        entityId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EntityLogDTO'][];
        };
      };
    };
  };
  adminEventReportControllerGetOptions: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ReportOptionsResponse'];
        };
      };
    };
  };
  adminEventReportControllerGenerateReport: {
    parameters: {
      query?: {
        startDate?: string;
        endDate?: string;
        eventTypes?: string;
        groupBy?: string;
        entityTypes?: string;
        businessId?: string;
        userId?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': unknown;
        };
      };
    };
  };
  adminEventReportControllerExportCsv: {
    parameters: {
      query?: {
        startDate?: string;
        endDate?: string;
        eventTypes?: string;
        groupBy?: string;
        entityTypes?: string;
        businessId?: string;
        userId?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  adminFilterControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        search?: string;
        enabled?: boolean;
        isMandatory?: boolean;
        sortBy?: string;
        sortOrder?: string;
        noPagination?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Filter'][];
        };
      };
    };
  };
  adminFilterControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminFilterCreateDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Filter'];
        };
      };
    };
  };
  adminFilterControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Filter'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminFilterControllerUpdate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminFilterUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Filter'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminFilterControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminImportJobControllerGetProviders: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown[];
        };
      };
    };
  };
  adminImportJobControllerListJobs: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobListDTO'][];
        };
      };
    };
  };
  adminImportJobControllerCreateJob: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['CreateImportJobDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
    };
  };
  adminImportJobControllerGetJobProgress: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminImportJobControllerDeleteJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  adminImportJobControllerGetJobItems: {
    parameters: {
      query?: {
        status?: string;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobItemDTO'][];
        };
      };
    };
  };
  adminImportJobControllerPauseJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
    };
  };
  adminImportJobControllerResumeJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
    };
  };
  adminImportJobControllerRetryFailedItems: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
    };
  };
  adminImportJobControllerCancelJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
    };
  };
  adminNotificationControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        type?: PathsAdminNotificationsGetParametersQueryType;
        source?: PathsAdminNotificationsGetParametersQuerySource;
        userId?: number;
        grouped?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Notification'][];
        };
      };
    };
  };
  adminNotificationControllerSend: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminSendNotificationDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Notification'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  adminNotificationControllerSendBulk: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminSendBulkNotificationDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Notification'][];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  adminNotificationControllerBroadcast: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminSendBroadcastDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  adminNotificationControllerFindByUser: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        type?: PathsAdminNotificationsUserUserIdGetParametersQueryType;
        source?: PathsAdminNotificationsUserUserIdGetParametersQuerySource;
        userId?: number;
        grouped?: boolean;
      };
      header?: never;
      path: {
        userId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Notification'][];
        };
      };
    };
  };
  adminPlanControllerFindAllByUser: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        filter?: PathsAdminUsersUserIdPlansGetParametersQueryFilter;
        sortBy?: string;
        sortOrder?: string;
      };
      header?: never;
      path: {
        userId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'][];
        };
      };
    };
  };
  adminPlanControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        userId: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminPlanCreateDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminPlanControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        userId: number;
        planId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminScoresControllerRecalculateAllScores: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchRecalculationResponse'];
        };
      };
    };
  };
  adminScoresControllerRecalculateSingleScore: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        businessId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SingleRecalculationResponse'];
        };
      };
    };
  };
  adminUsersControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        search?: string;
        role?: string;
        enabled?: boolean;
        sortBy?: string;
        sortOrder?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'][];
        };
      };
    };
  };
  adminUsersControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminUserCreateDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  adminUsersControllerGetMe: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerGetAuthProfile: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Auth0 profile data (email and phone) */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': Record<string, never>;
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerUpdate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminUserUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerUpdateRole: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UserRoleUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerGetUserAbilities: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': Record<string, never>;
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  businessControllerCreateBusiness: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['BusinessCreateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  businessControllerGetCities: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CityWithBusinessCount'][];
        };
      };
    };
  };
  businessControllerFindNearby: {
    parameters: {
      query: {
        longitude: number;
        latitude: number;
        userLongitude: number;
        userLatitude: number;
        searchText?: string;
        filterIds?: string;
        categoryIds?: string;
        page: number;
        limit: number;
        openStatus?: string;
        visitedStatus?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'][];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  businessControllerFindWithinArea: {
    parameters: {
      query: {
        latitude: number;
        longitude: number;
        latitudeDelta: number;
        longitudeDelta: number;
        userLongitude: number;
        userLatitude: number;
        searchText?: string;
        filterIds?: string;
        categoryIds?: string;
        openStatus?: string;
        visitedStatus?: string;
        minScore?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'][];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  businessControllerFindByName: {
    parameters: {
      query: {
        name: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  businessControllerCheckBusinessByProvider: {
    parameters: {
      query: {
        providerId: string;
        externalId: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': Record<string, never>;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  businessIdControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        businessId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  businessReviewsControllerFindReviews: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
      };
      header?: never;
      path: {
        businessId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessReview'][];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  businessReviewsControllerCreateReview: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        businessId: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['BusinessReviewCreateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessReview'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  businessReviewsControllerUpdateReview: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        businessId: string;
        reviewId: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['BusinessReviewCreateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessReview'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Forbidden'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Conflict'];
        };
      };
    };
  };
  categoryControllerGetAll: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description List of business categories */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Category'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  configControllerHealthCheck: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Health check successful */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': unknown;
        };
      };
    };
  };
  configControllerGetAppVersion: {
    parameters: {
      query?: {
        platform?: string;
        current_version?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Version check completed */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VersionResponse'];
        };
      };
      /** @description Invalid platform or version */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  favoriteControllerGetFavorites: {
    parameters: {
      query: {
        userLongitude: number;
        userLatitude: number;
        page: number;
        limit: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description User favorite businesses */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Favorite'][];
        };
      };
      /** @description Invalid coordinates or pagination */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  favoriteControllerSetFavoriteStatus: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['FavoriteUpdateDTO'];
      };
    };
    responses: {
      /** @description Favorite status updated */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Favorite'];
        };
      };
      /** @description Invalid request data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Business not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  filterControllerGetAll: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description List of business filters */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Filter'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  imageControllerGetDisplayImage: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImageResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  imageControllerGetThumbnail: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImageResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  imageControllerGetOriginal: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImageResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  imageControllerGetBySize: {
    parameters: {
      query?: {
        w?: number;
      };
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImageResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  notificationControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        unreadOnly?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Notification'][];
        };
      };
    };
  };
  notificationControllerGetUnreadCount: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UnreadCountResponse'];
        };
      };
    };
  };
  notificationControllerMarkAsRead: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        notificationId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Notification'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  notificationControllerMarkAllAsRead: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': unknown;
        };
      };
    };
  };
  notificationControllerGetSettings: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotificationSettingsResponseDTO'];
        };
      };
    };
  };
  notificationControllerUpdateSettings: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['NotificationSettingsUpdateRequestDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotificationSettingsResponseDTO'];
        };
      };
    };
  };
  planControllerGetByUser: {
    parameters: {
      query: {
        page: number;
        limit: number;
        filter: PathsPlanGetParametersQueryFilter;
        businessId?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description User plans retrieved successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'][];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Unauthorized'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  planControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['PlanCreateDTO'];
      };
    };
    responses: {
      /** @description Plan created successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'];
        };
      };
      /** @description Invalid plan data or business not found */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Unauthorized'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  planControllerDeletePlan: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        planId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Plan deleted successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Unauthorized'];
        };
      };
      /** @description Not authorized to delete this plan */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Unauthorized'];
        };
      };
      /** @description Plan not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Current user profile */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description User not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerUpdateUser: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UserUpdateDTO'];
      };
    };
    responses: {
      /** @description User updated successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Invalid user data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description User not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UserCreateDTO'];
      };
    };
    responses: {
      /** @description User created successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Invalid user data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description User already exists */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Conflict'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerDeleteAccount: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Account deleted successfully */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description User not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerCreateSocialUser: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SocialUserCreateDTO'];
      };
    };
    responses: {
      /** @description Social user created successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Invalid user data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Missing auth context */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Forbidden'];
        };
      };
      /** @description User already exists */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Conflict'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerGetAuthProfile: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Auth0 profile data (email and phone) */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': Record<string, never>;
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description User not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerSavePushToken: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['PushTokenCreateDTO'];
      };
    };
    responses: {
      /** @description Push token saved successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PushToken'];
        };
      };
      /** @description Invalid push token data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerCompleteOnboarding: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Onboarding marked as completed */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description User not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userEventControllerTrackEvent: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UserEventCreateDTO'];
      };
    };
    responses: {
      /** @description Event tracked successfully */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserEvent'];
        };
      };
      /** @description Invalid event data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  webControllerAppleAppSiteAssociation: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string;
        };
      };
    };
  };
  webControllerDigitalAssetLinks: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string;
        };
      };
    };
  };
  webControllerBusinessWebFallback: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        businessId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/html': string;
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  webControllerBusinessWebFallbackWithSlug: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        businessId: number;
        slug: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/html': string;
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
}
export enum PathsAdminBusinessesGetParametersQueryStatus {
  Pending = 'Pending',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum PathsAdminNotificationsGetParametersQueryType {
  plan_reminder = 'plan_reminder',
  plan_created_by_admin = 'plan_created_by_admin',
  review_reminder = 'review_reminder',
  announcement = 'announcement',
  marketing = 'marketing',
  system = 'system',
}
export enum PathsAdminNotificationsGetParametersQuerySource {
  system = 'system',
  admin = 'admin',
  scheduled = 'scheduled',
}
export enum PathsAdminNotificationsUserUserIdGetParametersQueryType {
  plan_reminder = 'plan_reminder',
  plan_created_by_admin = 'plan_created_by_admin',
  review_reminder = 'review_reminder',
  announcement = 'announcement',
  marketing = 'marketing',
  system = 'system',
}
export enum PathsAdminNotificationsUserUserIdGetParametersQuerySource {
  system = 'system',
  admin = 'admin',
  scheduled = 'scheduled',
}
export enum PathsAdminUsersUserIdPlansGetParametersQueryFilter {
  upcoming = 'upcoming',
  history = 'history',
}
export enum PathsPlanGetParametersQueryFilter {
  upcoming = 'upcoming',
  history = 'history',
}
export enum BackgroundJobListDTOType {
  import = 'import',
  score_recalculation = 'score-recalculation',
}
export enum BackgroundJobListDTOStatus {
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
  paused = 'paused',
  cancelled = 'cancelled',
}
export enum BackgroundJobProgressDTOType {
  import = 'import',
  score_recalculation = 'score-recalculation',
}
export enum BackgroundJobProgressDTOStatus {
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
  paused = 'paused',
  cancelled = 'cancelled',
}
export enum BusinessStatus {
  Pending = 'Pending',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum BusinessOpeningHourDayOfWeek {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}
export enum BusinessFilterLevel {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  NotAvailable = 'NotAvailable',
}
export enum FilterImportance {
  Critical = 'Critical',
  Important = 'Important',
  NiceToHave = 'NiceToHave',
}
export enum FilterNotAvailableImpact {
  Negative = 'Negative',
  Neutral = 'Neutral',
}
export enum BusinessReviewFilterLevel {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  NotAvailable = 'NotAvailable',
}
export enum AdminBusinessUpdateDTOStatus {
  Pending = 'Pending',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum AdminOpeningHourDTODayOfWeek {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}
export enum AdminBusinessStatusUpdateDTOStatus {
  Pending = 'Pending',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum MapProviderInfoDTOIdentifier {
  google_maps = 'google_maps',
}
export enum ImportBusinessesDTOStatus {
  Pending = 'Pending',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum CachedMapResponseDTOProvider {
  google_maps = 'google_maps',
}
export enum ImportJobProgressDTOStatus {
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
  paused = 'paused',
  cancelled = 'cancelled',
}
export enum ImportJobListDTOStatus {
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
  paused = 'paused',
  cancelled = 'cancelled',
}
export enum ImportJobItemDTOStatus {
  pending = 'pending',
  processing = 'processing',
  success = 'success',
  failed = 'failed',
  skipped = 'skipped',
}
export enum NotificationType {
  plan_reminder = 'plan_reminder',
  plan_created_by_admin = 'plan_created_by_admin',
  review_reminder = 'review_reminder',
  announcement = 'announcement',
  marketing = 'marketing',
  system = 'system',
}
export enum NotificationSource {
  system = 'system',
  admin = 'admin',
  scheduled = 'scheduled',
}
export enum AdminSendNotificationDTOType {
  plan_reminder = 'plan_reminder',
  plan_created_by_admin = 'plan_created_by_admin',
  review_reminder = 'review_reminder',
  announcement = 'announcement',
  marketing = 'marketing',
  system = 'system',
}
export enum AdminSendBulkNotificationDTOType {
  plan_reminder = 'plan_reminder',
  plan_created_by_admin = 'plan_created_by_admin',
  review_reminder = 'review_reminder',
  announcement = 'announcement',
  marketing = 'marketing',
  system = 'system',
}
export enum AdminSendBroadcastDTOType {
  plan_reminder = 'plan_reminder',
  plan_created_by_admin = 'plan_created_by_admin',
  review_reminder = 'review_reminder',
  announcement = 'announcement',
  marketing = 'marketing',
  system = 'system',
}
export enum UserRoleUpdateDTORole {
  platform_admin = 'platform_admin',
  platform_support = 'platform_support',
  platform_marketing = 'platform_marketing',
  business_owner = 'business_owner',
  business_manager = 'business_manager',
  business_staff = 'business_staff',
  user = 'user',
}
export enum AdminUserCreateDTORole {
  platform_admin = 'platform_admin',
  platform_support = 'platform_support',
  platform_marketing = 'platform_marketing',
  business_owner = 'business_owner',
  business_manager = 'business_manager',
  business_staff = 'business_staff',
  user = 'user',
}
export enum AdminUserUpdateDTORole {
  platform_admin = 'platform_admin',
  platform_support = 'platform_support',
  platform_marketing = 'platform_marketing',
  business_owner = 'business_owner',
  business_manager = 'business_manager',
  business_staff = 'business_staff',
  user = 'user',
}
export enum BusinessCreateOpeningHourDTODayOfWeek {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}
export enum BusinessCreateRatingDTOLevel {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  NotAvailable = 'NotAvailable',
}
export enum BusinessReviewFilterCreateDTOLevel {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  NotAvailable = 'NotAvailable',
}
export enum UserEventEntityType {
  business = 'business',
  plan = 'plan',
  review = 'review',
  user = 'user',
  favorite = 'favorite',
  import_job = 'import_job',
}
export enum UserEventSource {
  mobile = 'mobile',
  admin = 'admin',
  api = 'api',
}
export enum UserEventCreateDTOEventType {
  business_viewed = 'business_viewed',
  business_favorited = 'business_favorited',
  business_unfavorited = 'business_unfavorited',
  business_created = 'business_created',
  plan_created = 'plan_created',
  plan_deleted = 'plan_deleted',
  review_submitted = 'review_submitted',
  review_edited = 'review_edited',
  user_registered = 'user_registered',
  user_deleted = 'user_deleted',
  filter_selected = 'filter_selected',
  category_selected = 'category_selected',
  search_performed = 'search_performed',
  admin_business_viewed = 'admin_business_viewed',
  admin_business_updated = 'admin_business_updated',
  admin_business_status_changed = 'admin_business_status_changed',
  admin_business_deleted = 'admin_business_deleted',
  admin_business_refreshed = 'admin_business_refreshed',
  admin_business_map_reference_updated = 'admin_business_map_reference_updated',
  admin_user_viewed = 'admin_user_viewed',
  admin_user_updated = 'admin_user_updated',
  admin_user_status_changed = 'admin_user_status_changed',
  admin_user_deleted = 'admin_user_deleted',
  admin_user_role_changed = 'admin_user_role_changed',
  admin_review_visibility_changed = 'admin_review_visibility_changed',
  admin_review_score_inclusion_changed = 'admin_review_score_inclusion_changed',
  admin_import_job_created = 'admin_import_job_created',
  admin_import_job_paused = 'admin_import_job_paused',
  admin_import_job_resumed = 'admin_import_job_resumed',
  admin_import_job_cancelled = 'admin_import_job_cancelled',
  admin_import_job_completed = 'admin_import_job_completed',
  admin_import_job_deleted = 'admin_import_job_deleted',
  admin_import_job_retry = 'admin_import_job_retry',
  admin_score_recalculated = 'admin_score_recalculated',
  admin_score_batch_recalculated = 'admin_score_batch_recalculated',
}
export enum UserEventCreateDTOEntityType {
  business = 'business',
  plan = 'plan',
  review = 'review',
  user = 'user',
  favorite = 'favorite',
  import_job = 'import_job',
}
export enum UserEventCreateDTOSource {
  mobile = 'mobile',
  admin = 'admin',
  api = 'api',
}
